export default __webpack_public_path__ + "static/media/triangle.ab00bc94.svg";